/**
 * Extract the asset id from an internal asset URL (/api/assets/{id} or
 * /assets/{id}). Returns null for external URLs — nothing we can delete from
 * our own object store.
 */
export function assetIdFromUrl(url: string | null | undefined): string | null {
  if (!url) return null
  const m = url.match(/\/assets\/([^/?#]+)/)
  return m ? m[1] : null
}
